import { render, staticRenderFns } from "./conta-bancaria.vue?vue&type=template&id=112a0a28&"
import script from "./conta-bancaria.vue?vue&type=script&lang=js&"
export * from "./conta-bancaria.vue?vue&type=script&lang=js&"
import style0 from "./conta-bancaria.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports